import { PaymentsContainer as Payments } from "./Payments.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default Payments;
